module.exports = __webpack_public_path__ + "static/img/ent-33.9ac5581.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-33.jpg
// module id = 6sO4
// module chunks = 51